import { AxiosResponse } from "axios";
import instance from "../instance";
import {
  CreateUploadInterface,
  UploadFileToSessionInterface,
} from "@/core/reatom/state/upload/types";
import { Files } from "@/core/reatom/state/currentService/currentService";

interface UploadSession {
  type?: string;
  oid: string;
}

export interface UploadFileToSessionBodyInterface {
  session_id: string;
  files: FileList;
}

export interface DeleteFileToSessionBodyInterface {
  session_id: string;
  files: Files;
}

export const createUploadFile = async ({
  type = "order_message",
  oid = "193534",
}: UploadSession): Promise<CreateUploadInterface> => {
  const res: AxiosResponse<CreateUploadInterface> = await instance.post(
    "/v1/upload/session",
    {
      type,
      options: {
        order_id: oid,
      },
    },
    {
      params: {
        type: type,
      },
    }
  );
  return res.data;
};

export const uploadFileToSession = async ({
  session_id,
  files,
}: UploadFileToSessionBodyInterface): Promise<UploadFileToSessionInterface> => {
  const formData = new FormData();

  formData.append("session_id", session_id);

  for (let i = 0; i < files.length; i++) {
    formData.append("files[]", files[i]);
  }

  const res: AxiosResponse<UploadFileToSessionInterface> = await instance.post(
    "/v1/upload",
    formData
  );
  return res.data;
};

export const deleteFileToSession = async ({
  session_id,
  files,
}: DeleteFileToSessionBodyInterface): Promise<{ files: Files[] }> => {
  const res: AxiosResponse<{ files: Files[] }> = await instance.delete(
    "/v1/upload/delete-files",
    {
      params: {
        session_id: session_id,
        "files_to_remove[]": files.id,
      },
    }
  );

  return res.data;
};
